import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { LookupDetail } from 'src/app/core/models/lookup-detail.model';
import { LiftBoardService } from './lift-board.service';


@Injectable({ providedIn: 'root' })
export class LiftBoardLookupResolver implements Resolve<HttpResponse<LookupDetail[]>> {
  constructor(
    private liftBoardService: LiftBoardService
  ) { }

  resolve() {
    const httpParams = new HttpParams()
      .set('orderby', 'Title asc');
    return this.liftBoardService.get(httpParams);
  }
}
